import axios from 'axios';
import createBusinessCardPayload from '../utils/createBusinessCardPayload';
import groupImagesByType from '../utils/groupImagesByType';
import businessCardModel from '../models/businessCard';

const businessCardService = {
    fetchBusinessCard(businessName){
        
        return axios.get(`/api/cards/${businessName}`)
        .then((res)=>{
            console.log(res)
            
            const {actions,settings,clientInfo,images,status} = res.data.data;
            //TODO: MOVE THIS TO BUSINESS CARD TRANSFORMER?
            //const groupedImages = groupImagesByType(images);
            const businessCard = businessCardModel(actions,clientInfo,images,settings,status);

            return businessCard;
        })
        .catch((err) => {
            throw(err);
        });

    },
    async updateBusinessCard(businessCard,deletedActions,deletedImages){
        
        const businessName = businessCard.clientInfo.businessname;
        const payload = createBusinessCardPayload(businessCard,deletedActions,deletedImages);

        try{

            const result = await axios.post(`/api/cards/${businessName}`,payload);
            const businessCard = result.data.data;

            return {
                success: true,
                data: businessCard
            }

        }
        catch(e){

            return {
                success: false,
                error: e
            }

        }

    },
    async createBusinessCard(businessCard){

        const businessName = businessCard.clientInfo.businessname ? businessCard.clientInfo.businessname : businessCard.clientInfo.name;
        const payload = createBusinessCardPayload(businessCard);

        try{

            const result = await axios.put(`/api/cards/${businessName}`,payload)
            const businessCard = result.data.data;

            return {
                success:true,
                data: businessCard
            }
        }
        catch(e){

            return {
                success: false,
                error: e
            }

        }

    }
}

export default businessCardService;